(() => {
  const header = document.querySelector('[data-shared-header]');
  if (!header) return;

  const root = document.documentElement;
  const menuButton = header.querySelector('.menu-toggle');
  const menu = document.querySelector('#mobile-menu');
  const themeButton = header.querySelector('.theme-toggle');
  const chatButton = header.querySelector('[data-chat-launcher]');
  const desktop = window.matchMedia('(min-width: 900px)').matches;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let returningTimer;
  let wasDocked = false;
  let scrollQueued = false;

  const syncHeader = () => {
    const docked = window.scrollY > 72;
    if (docked !== wasDocked) {
      window.clearTimeout(returningTimer);
      if (docked) {
        header.classList.remove('is-returning');
        header.classList.add('is-docked');
      } else if (!desktop && header.classList.contains('is-docked')) {
        header.classList.add('is-returning');
        returningTimer = window.setTimeout(() => header.classList.remove('is-docked', 'is-returning'), reduced ? 0 : 280);
      } else {
        header.classList.remove('is-docked', 'is-returning');
      }
      wasDocked = docked;
    }
    scrollQueued = false;
  };

  const closeMenu = () => {
    menuButton?.setAttribute('aria-expanded', 'false');
    menuButton?.setAttribute('aria-label', 'Open menu');
    menu?.setAttribute('aria-hidden', 'true');
    menu?.querySelectorAll('.mobile-menu__b2b[open]').forEach(details => details.removeAttribute('open'));
    document.body.classList.remove('menu-open');
  };

  const syncTheme = () => {
    const dark = root.dataset.theme === 'dark';
    themeButton?.setAttribute('aria-label', dark ? 'Switch to light theme' : 'Switch to dark theme');
    themeButton?.setAttribute('aria-pressed', String(dark));
    const label = themeButton?.querySelector('b');
    if (label) label.textContent = dark ? 'Dark' : 'Light';
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.content = dark ? '#15110e' : '#f2ecdf';
  };

  window.addEventListener('scroll', () => {
    if (!scrollQueued) {
      window.requestAnimationFrame(syncHeader);
      scrollQueued = true;
    }
  }, { passive: true });

  menuButton?.addEventListener('click', () => {
    const open = menuButton.getAttribute('aria-expanded') === 'true';
    menuButton.setAttribute('aria-expanded', String(!open));
    menuButton.setAttribute('aria-label', open ? 'Open menu' : 'Close menu');
    menu?.setAttribute('aria-hidden', String(open));
    document.body.classList.toggle('menu-open', !open);
  });

  menu?.querySelectorAll('a').forEach(link => link.addEventListener('click', closeMenu));
  const closeB2BMenu = () => {
    document.querySelectorAll('.nav-b2b[open], .mobile-menu__b2b[open]').forEach(details => details.removeAttribute('open'));
  };
  document.addEventListener('pointerdown', event => {
    if (!event.target.closest('.nav-b2b, .mobile-menu__b2b')) closeB2BMenu();
    if (document.body.classList.contains('menu-open') && !event.target.closest('.mobile-menu, .menu-toggle')) closeMenu();
  });
  window.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    closeB2BMenu();
    closeMenu();
  });

  root.dataset.theme = localStorage.getItem('cg-theme') === 'dark' ? 'dark' : 'light';
  syncTheme();
  themeButton?.addEventListener('click', () => {
    root.dataset.theme = root.dataset.theme === 'dark' ? 'light' : 'dark';
    localStorage.setItem('cg-theme', root.dataset.theme);
    syncTheme();
  });

  const connectChat = () => {
    const api = window.tidioChatApi;
    if (!api || typeof api.open !== 'function' || !chatButton || !chatButton.hidden) {
      return Boolean(api && chatButton && !chatButton.hidden);
    }
    root.classList.add('chat-nav-ready');
    chatButton.hidden = false;
    chatButton.addEventListener('click', () => {
      closeMenu();
      document.body.classList.add('chat-open');
      chatButton.setAttribute('aria-expanded', 'true');
      if (typeof api.show === 'function') api.show();
      window.requestAnimationFrame(() => api.open());
    });
    if (typeof api.on === 'function') {
      api.on('open', () => {
        document.body.classList.add('chat-open');
        chatButton.setAttribute('aria-expanded', 'true');
      });
      api.on('close', () => {
        document.body.classList.remove('chat-open');
        chatButton.setAttribute('aria-expanded', 'false');
      });
    }
    return true;
  };

  document.addEventListener('tidioChat-ready', connectChat);
  if (!connectChat()) {
    let attempts = 0;
    const timer = window.setInterval(() => {
      attempts += 1;
      if (connectChat() || attempts >= 40) window.clearInterval(timer);
    }, 250);
  }

  syncHeader();
})();
